const TAKE = 100
const TAKEBOOKINGS = 400

/**
 * Fecha límite para validar si una oportunidad fue migrada a la nueva versión de XTS.
 * Si la fecha fin del booking es anterior a esta fecha, se considera que no fue migrada.
 * Formato: 'YYYY-MM-DD'
 * Modificar esta constante según la fecha de salida a producción.
 */
const FECHA_LIMITE_MIGRACION_XTS = '2026-01-01'

const heightDialogCustom = '800px'
const heightWindowCustom = 600
const heightWindowExtra = 800
const heightWindowMedio = 700
const heightGridCustom = '75vh'
const heightGrid90 = '90vh'
const heightGrid80 = '80vh'
const heightCard80 = '80vh'

const tipoReserva = {
  alimento: 'Alimento',
  hotel: 'Hotel',
}

/** Opciones de paginacion estandar para todos los grids del proyecto */
const PAGE_SIZE_GRID = [50, 100, 200]

/**
 * Estados del booking en los que la matriz permite operar sus actividades (unir rutas, boletos, etc.).
 * La oportunidad ganada entra como Abierto y pasa a Operación después; el backend acepta los dos
 * (ReservaBoletosSupervisor / MatrizAsignacionSupervisor) y el 1.0 en producción ya no bloqueaba por estado.
 */
const ESTADOS_BOOKING_OPERABLES = ['Operación', 'Abierto']

// Avatar por defecto cuando el usuario no tiene foto en su perfil de Graph
const sinFoto = '/assets/images/avatar-default.png'

export {
  heightCard80,
  heightDialogCustom,
  heightGrid80,
  heightGrid90,
  heightGridCustom,
  heightWindowCustom,
  heightWindowExtra,
  heightWindowMedio,
  TAKE,
  TAKEBOOKINGS,
  PAGE_SIZE_GRID,
  ESTADOS_BOOKING_OPERABLES,
  tipoReserva,
  sinFoto,
  FECHA_LIMITE_MIGRACION_XTS,
}
